import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-utility-brand-50 text-text-brand-secondary',
        secondary: 'bg-bg-tertiary text-text-tertiary',
        success: 'bg-utility-brand-50 text-text-brand-secondary',
        warning: 'bg-[#fef3c7] text-[var(--color-utility-warning-600)]',
        danger: 'bg-bg-error-secondary text-text-error',
        outline: 'border border-border-secondary bg-utility-gray-50 text-text-secondary',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
